export const INIT = 0;
export const REJECTED = 1;
export const CONFIRMED = 2;
export const CALCULATED = 3;
export const CASHOUT = 4;
export const BET_PAY_REQUEST = 5;
export const IN_DELAY = 6;
export const STAKE_REQUEST = 7;
export const CONFIRM_AWAIT = 8;



// WEBPACK FOOTER //
// ./js/constants/BetStatus.js